import { FC } from 'react'
import {
  MdFormatBold,
  MdFormatItalic,
  MdFormatUnderlined,
} from 'react-icons/md'
import { Style } from '../../../lib/Types'

type Props = {
  style: Style
  isActive: boolean
  isEnabled: boolean
  toggle: () => void
}

const CellStyling: FC<Props> = ({ style, isActive, isEnabled, toggle }) => {
  const classNames = ['inline-block', 'p-1', 'ml-3']

  if (isActive) {
    classNames.push('text-black')
  } else {
    classNames.push('text-gray-300')
  }

  if (isEnabled) {
    classNames.push('bg-blue-100')
  }

  return (
    <div className='inline-block'>
      {style === 'font-bold' && (
        <MdFormatBold
          className={classNames.join(' ')}
          size='1.75rem'
          onClick={toggle}
        />
      )}
      {style === 'italic' && (
        <MdFormatItalic
          className={classNames.join(' ')}
          size='1.75rem'
          onClick={toggle}
        />
      )}
      {style === 'underline' && (
        <MdFormatUnderlined
          className={classNames.join(' ')}
          size='1.75rem'
          onClick={toggle}
        />
      )}
    </div>
  )
}

export default CellStyling
